<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00195 0.00292969C3.13633 0.00292969 0.00195312 3.1373 0.00195312 7.00293C0.00195312 10.8686 3.13633 14.0029 7.00195 14.0029C10.8676 14.0029 14.002 10.8686 14.002 7.00293C14.002 3.1373 10.8676 0.00292969 7.00195 0.00292969ZM7.00195 12.8154C3.79258 12.8154 1.18945 10.2123 1.18945 7.00293C1.18945 3.79356 3.79258 1.19043 7.00195 1.19043C10.2113 1.19043 12.8145 3.79356 12.8145 7.00293C12.8145 10.2123 10.2113 12.8154 7.00195 12.8154Z"
      fill="black"
      fill-opacity="0.25"
    />
    <path
      d="M9.73176 8.97959L7.50364 7.36865V3.50146C7.50364 3.43271 7.44739 3.37646 7.37864 3.37646H6.62708C6.55833 3.37646 6.50208 3.43271 6.50208 3.50146V7.80459C6.50208 7.84522 6.52083 7.88272 6.55364 7.90615L9.13801 9.79053C9.19426 9.83115 9.27239 9.81865 9.31301 9.76397L9.75989 9.15459C9.80051 9.09678 9.78801 9.01865 9.73176 8.97959Z"
      fill="black"
      fill-opacity="0.25"
    />
  </svg>
</template>

<script>
export default {

}
</script>

<style>
</style>


// WEBPACK FOOTER //
// ClockCircle.vue?61ad04c9